import { Component, OnInit } from '@angular/core';
import { ExportMode, IWizardExportPageComponent } from '@barthauer/abc/interfaces/core/wizards/wizard-export';
import { GisExportService } from '../../gis-export.service';
import { GisExportWizardTransferObject, GisWizardExportMode } from '../../models/export.model';
import { FeatureGeometryType, MapService } from '@barthauer/abc/graphics/adapters/open-layers';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'export-mode-selection-page',
  templateUrl: './export-mode-selection-page.component.html',
  styleUrls: ['./export-mode-selection-page.component.scss'],
  standalone: false,
})
export class ExportModeSelectionPageComponent implements OnInit, IWizardExportPageComponent {
  public resAsync: Promise<ResourceSet>;
  public res = ResourceSet.Empty;
  public selectedExportMode: ExportMode = ExportMode.VisibleArea;
  public transferObject: object;
  public selectedPolygon: number[][];
  private destroy$ = new Subject<void>();

  get isValid(): boolean {
    if (this.selectedExportMode === ExportMode.MarkedArea && !this.selectedPolygon) {
      return false;
    }

    return true;
  }

  get invalidMessage(): string {
    return this.res.get('PolygonValidationMessage');
  }

  constructor(
    private gisExportService: GisExportService,
    private mapService: MapService,
    private resourceService: ResourceManagerService
  ) {
    this.resAsync = this.resourceService.getResourceSet('gis-export');
  }

  async ngOnInit() {
    this.res = await this.resAsync;

    this.mapService
      .onFeatureSelectionCanceled()
      .pipe(takeUntil(this.destroy$))
      .subscribe((isCanceled) => {
        if (isCanceled) {
          this.gisExportService.maximizeWizardWindow();
          this.gisExportService.windowInstance?.updateShading(true);
        }
      });
  }

  public onNext(): void {
    (this.transferObject as GisExportWizardTransferObject).exportMode = this
      .selectedExportMode as unknown as GisWizardExportMode;
  }

  public async selectPolygon(): Promise<void> {
    this.gisExportService.minimizeWizardWindow();
    this.gisExportService.windowInstance?.updateShading(false);
    this.selectedPolygon = await this.mapService.startInteractiveGeometryCapture(FeatureGeometryType.Polygon);

    if (this.selectedPolygon) {
      this.gisExportService.filterPolygon = this.selectedPolygon;
      this.gisExportService.maximizeWizardWindow();
      this.gisExportService.windowInstance?.updateShading(true);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
